import axios from 'axios';
import { useApiConfigStore } from '@store/api_config';

const publicClient = axios.create();

publicClient.interceptors.request.use((config) => {
  config.baseURL = useApiConfigStore.getState().getApiUrl();
  return config;
});

export interface TrackingData {
  ordre_num: string;
  org_name: string;
  org_address?: string;
  org_phone?: string;
  org_email?: string;
  tracking_step: string;
  has_carte_grise: boolean;
  vehicle_plate?: string;
  vehicle_marque?: string;
  vehicle_modele?: string;
  vehicle_coloris?: string;
  service_type?: string;
  intervention_type?: string;
  interventions?: string[];
  deposit_date?: string;
  restitution_date?: string;
  mobility_option?: string;
  tire_option?: string;
  client_rating?: number;
  devis_pdf_url?: string;
  devis_sign_token?: string;
  devis_sign_status?: string;
}

export const getTrackingData = (ordreId: string): Promise<TrackingData> =>
  publicClient.get(`/ordres/${ordreId}/tracking`).then((r) => r.data);

export const submitTrackingRating = (ordreId: string, rating: number): Promise<void> =>
  publicClient.post(`/ordres/${ordreId}/tracking/rating`, { rating });
